export default {
    asc:  'ASC',
    desc: 'DESC',
};
